import React, {useCallback, useContext, useState} from "react";
import {WizardFormInput} from "./WizardFormInput";
import {WizardContext} from "../Wizard";
import {ListGroup} from "react-bootstrap";
import {CHANGE_OPTION_DATA, SET_MIN_AND_MAX_PRICE} from "../../WizardConstants";
import {WizardFormTitle} from "../wizardForm/wizardFormTitle";

const listItem = (data, key, onClick) => {
    return data.optionList
            .map((item, i) =>
                <ListGroup.Item
                    active={key === item.idx}
                    onClick={(e) => onClick(item.idx)}
                    key={"list-" + i}>
                    {item.name}
                </ListGroup.Item>)

}

export function WizardFormListGroup({data}) {
    const {dispatch} = useContext(WizardContext);
    const [directInput, setDirectInput] = useState(false);
    const [key, setKey] = useState(null);
    const [optionDescription, setOptionDescription] = useState('');

    const onClick = useCallback(
        (idx) => {
            let optionName = '', optionValue = 0, price_min = 0, price_max = 0, direct = true;

            if (idx !== "-") {
                const selectedOption = data.optionList.find(item => item.idx === parseInt(idx))
                optionName = selectedOption.name;
                optionValue = selectedOption.idx;
                price_min = selectedOption.price_min;
                price_max = selectedOption.price_max;
                direct = false;

                setOptionDescription(selectedOption.description);
            }

            dispatch({
                type: CHANGE_OPTION_DATA,
                dataName: data.name,
                optionName: optionName,
                optionValue: optionValue,
                price_min: price_min,
                price_max: price_max,
            })
            dispatch({
                type: SET_MIN_AND_MAX_PRICE,
            })

            setKey(idx)
            setDirectInput(direct)

        },
        [dispatch, data],
    );

    return (
        <div className="form-group">
            <WizardFormTitle description={data.description} musthave={data.musthave} name={data.name}/>
            <ListGroup>
                {listItem(data, key, onClick)}
                {
                    data.direct_yn === "Y" &&
                    <ListGroup.Item active={key === "-"}
                                    onClick={(e) => onClick("-")}>
                        직접입력
                    </ListGroup.Item>
                }
            </ListGroup>
            {optionDescription.length > 0 ?
            <span className="btn btn-md bg-white-o-15 mr-4">
              <i className="flaticon2-shopping-cart-1 text-success"></i>
              {optionDescription}
            </span> : ''}
            {(data.direct_yn && directInput) && <WizardFormInput data={data}/>}
        </div>

    )

}